module.exports = __webpack_public_path__ + "img/idcard4.23756846.png";